export const PROGRAM_FEE_1_CONSTANTS = {
  PROGRAM_FEE_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Program Fee Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "note",
      label: "Note",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter note (optional)",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "note_text_color",
      label: "Note Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter note text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "other_fee",
      label: "Other Fee",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter other fee information",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Program Fee Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Fee",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "table_header_background_color",
      label: "Table Header Background Color",
      value: "#f5f5f5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter table header background color (e.g., #f5f5f5)",
      required: false,
      defaultValue: "#f5f5f5",
    },
    {
      fieldName: "cta_button_text",
      label: "CTA Button Text",
      value: "Learn More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button text",
      required: false,
      defaultValue: "Learn More",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "cta_button_icon",
      label: "CTA Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA button icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_icon_alt",
      label: "CTA Button Icon Alt Text",
      value: "Learn more",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button icon alt text",
      required: false,
      defaultValue: "Learn more",
    },
  ],
};

